import {filterItemsWithOptions} from './helpers';
import {importationsOptions, getImportationsOptions} from './importationsMenuBuilder';
import {partsOptions, getPartsOptions} from './partsMenuBuilder';
import {servicesOptions, getServicesOptions} from './servicesMenuBuilder';
import {vehiclesOptions, getVehiclesOptions} from './vehiclesMenuBuilder';
import {technologyOptions, getTechnologyOptions} from './technologyMenuBuilder';
import {accessoriesOptions, getAccessoriesOptions} from './accessoriesBuilder';
import {warrantiesOptions, getWarrantiesOptions} from './warrantiesMenuBuilder';
import {happyWaitOptions, getWaitHappyOptions} from './marketingMenuBuilder';
import {commercialOptions, getCommercialOptions} from './commercialMenuBuilder';
import {accountOptions, getAccountOptions} from './accountMenuBuilder';
import {wtsOptions} from './wtsMenuBuilder';

export const getMenuItems = (permissions) => {
  const items = [{
    'icon': 'dashboard',
    'name': 'COMERCIAL',
    'options': getCommercialOptions(permissions),
  }, {
    'icon': 'chart bar',
    'name': 'IMPORTACIONES',
    'options': getImportationsOptions(permissions),
  }, {
    'icon': 'dashboard',
    'name': 'REPUESTOS',
    'options': getPartsOptions(permissions),
  }, {
    'icon': 'dashboard',
    'name': 'SERVICIO',
    'options': getServicesOptions(permissions),
  }, {
    'icon': 'mouse pointer',
    'name': 'TECNOLOGÍA',
    'options': getTechnologyOptions(permissions),
  }, {
    'icon': 'car',
    'name': 'VEHÍCULOS',
    'options': getVehiclesOptions(permissions),
  }, {
    'icon': 'dashboard',
    'name': 'LOGÍSTICA',
    'options': getAccessoriesOptions(permissions),
  }, {
    'icon': 'dashboard',
    'name': 'GARANTÍAS',
    'options': getWarrantiesOptions(permissions),
  }, {
    'icon': 'dashboard',
    'name': 'MARKETING',
    'options': getWaitHappyOptions(permissions),
  }, {
    'icon': 'dashboard',
    'name': 'CONTABILIDAD',
    'options': getAccountOptions(permissions),
  }];
  
  return filterItemsWithOptions(items);
};

export const availableOptions = [
  ...commercialOptions,
  ...importationsOptions,
  ...partsOptions,
  ...servicesOptions,
  ...vehiclesOptions,
  ...technologyOptions,
  ...accessoriesOptions,
  ...warrantiesOptions,
  ...happyWaitOptions,
  ...accountOptions,
  ...wtsOptions,
];
